module.exports = __webpack_public_path__ + "img/mex.e0cd5de6.svg";